export default "__VITE_ASSET__unRBiM_1__"